/**
 * Nome da empresa logada para textos fora do React (comanda, WhatsApp,
 * impressão). O AuthProvider mantém estes valores em dia via setCompanyContext.
 * Owner em "Todas as empresas" não tem empresa atual: aí vale a empresa do
 * próprio pedido (`company_code`), buscada na lista de empresas.
 */
let currentName = "";
let namesByCode = new Map();

export const setCompanyContext = ({ name, companies } = {}) => {
  currentName = String(name ?? "").trim();
  namesByCode = new Map(
    (Array.isArray(companies) ? companies : [])
      .filter((c) => c?.code && c?.name)
      .map((c) => [String(c.code), String(c.name).trim()])
  );
};

/** Nome da empresa do pedido (ou da empresa logada); "" se desconhecido */
export const getCompanyName = (order) =>
  String(order?.company_name ?? "").trim() ||
  namesByCode.get(String(order?.company_code ?? "")) ||
  currentName;
